<template>
  <a-row>
    <a-spin :spinning="loading">
      <a-card :title="textbookDetail.title">
        <!-- <a slot="extra" @click="openVersionListModal">{{ $moment(currentVersion.gmtCreate).format('yyyy-MM-DD HH:mm:ss') }} 版</a> -->
        <a-row>
          <a-col span="6">
            <img style="width: 30%"
              :src="textbookDetail.thumbUrl"/>
          </a-col>
          <a-col span="18" style="padding-left: 20px">
            {{textbookDetail.summary}}
          </a-col>
        </a-row>
      </a-card>
      <a-divider/>
      <div class="chapter-view">
        <div v-for="item in versionList" :key="item.id"> 
          <div style="display: flex;flex-direction: row;justify-content: space-between;margin-bottom: 16px;"> 
            <div> 
              <div>
                <div style="font-weight: bold;"> 
                  提交人:{{ item.submitter ? item.submitter.name : '--' }}
                  <a-tag v-if="item.auditStatus == 1" color="blue">待审核</a-tag>
                  <a-tag v-if="item.auditStatus == 2" color="green">审核通过</a-tag>
                  <a-tag v-if="item.auditStatus == -2" color="red">审核不通过</a-tag>
                  <a-tag v-if="item.auditStatus == -1" color="orange">撤回</a-tag>
                </div>
                <div style="font-size: 10px;"> 
                  {{ $moment(item.gmtCreate).format('yyyy-MM-DD HH:mm:ss') }}
                </div>
                <div style="margin-top: 10px;"> 
                  {{ item.summary }}
                </div>
              </div>
              <div v-if="item.auditStatus == 2 || item.auditStatus == -2">
                <div style="font-weight: bold;"> 
                  审核人:{{ item.auditor ? item.auditor.name : '--' }}
                </div>
                <div style="font-size: 10px;"> 
                  {{ $moment(item.gmtModified).format('yyyy-MM-DD HH:mm:ss') }}
                </div>
                <div style="margin-top: 10px;"> 
                  {{ item.auditComment }}
                </div>
              </div>
            </div>
            <div> 
              <a v-if="item.auditStatus == 1 || item.auditStatus == 2" type="primary" size="small" @click="() => openVersionListModal(item)">详情</a>
            </div>
          </div>
          <a-divider />
        </div>
        <!-- <a-table :columns="versionColumns" :data-source="versionList">
          <a slot="gmtCreate" slot-scope="text, record"> {{ $moment(record.gmtCreate).format('yyyy-MM-DD HH:mm:ss') }} 版 </a>
          <div slot="auditStatus" slot-scope="text, record">
            <a-tag v-if="record.auditStatus == -2" color="red">审核不通过</a-tag>
            <a-tag v-if="record.auditStatus == -1" color="red">撤回</a-tag>
            <a-tag v-if="record.auditStatus == 0" color="blue">待上传</a-tag>
            <a-tag v-if="record.auditStatus == 1" color="blue">待审核</a-tag>
            <a-tag v-if="record.auditStatus == 2" color="green">审核通过</a-tag>
          </div>
          <span slot="submitter" slot-scope="text, record">
            {{ record.submitter ? record.submitter.name : '--' }}
          </span>
          <span slot="auditor" slot-scope="text, record">
            {{ record.auditor ? record.auditor.name : '--' }}
          </span>
          <span slot="action" slot-scope="text, record">
            <a v-if="currentVersionId == record.id" @click="() => openVersionListModal(record)">详情</a>
          </span>
        </a-table> -->
      </div>
      <a-modal v-model="auditModalVisible" title="审核" @ok="handleAuditOk" :confirmLoading="loading">
        <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-model-item label="审核结果">
            <a-select v-model="auditForm.auditStatus" placeholder="请选择审核结果">
              <a-select-option :value="2">
                通过
              </a-select-option>
              <a-select-option :value="-2">
                不通过
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="审核意见">
            <a-input v-model="auditForm.auditComment" type="textarea" />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
      <a-drawer
        :title="$moment(currentVersion.gmtCreate).format('yyyy-MM-DD HH:mm:ss')"
        placement="right"
        :closable="true"
        width="80%"
        @close="closeVersionListModal"
        :visible="versionListModalVisible">
        <div> 
          <a-steps v-if="currentVersion.auditStatus == 0 && currentVersion.onlineStatus != 1" :current="0">
            <a-step title="待上传" :sub-title="$moment(currentVersion.gmtCreate).format('yyyy-MM-DD HH:mm:ss')" description="This is a description.">
              <span slot="description">{{ currentVersion.submitter ? currentVersion.submitter.name : '--' }} : {{ currentVersion.summary }}</span>
            </a-step>
            <a-step title="未审核"/>
            <a-step title="未发布"/>
          </a-steps>
          <a-steps v-if="currentVersion.auditStatus == 1 && currentVersion.onlineStatus != 1" :current="1">
            <a-step title="上传完毕" :sub-title="$moment(currentVersion.gmtModified).format('yyyy-MM-DD HH:mm:ss')">
              <span slot="description">{{ currentVersion.submitter ? currentVersion.submitter.name : '--' }} : {{ currentVersion.summary }}</span>
            </a-step>
            <a-step title="待审核">
              <span slot="description">
              </span>
            </a-step>
            <a-step title="未发布"/>
          </a-steps>
          <a-steps v-if="currentVersion.auditStatus == 2 && currentVersion.onlineStatus != 1" :current="2">
            <a-step title="上传完毕" :sub-title="$moment(currentVersion.gmtModified).format('yyyy-MM-DD HH:mm:ss')">
              <span slot="description">{{ currentVersion.submitter ? currentVersion.submitter.name : '--' }} : {{ currentVersion.summary }}</span>
            </a-step>
            <a-step title="审核通过" :sub-title="$moment(currentVersion.auditTime).format('yyyy-MM-DD HH:mm:ss')">
              <span slot="description">{{ currentVersion.auditor ? currentVersion.auditor.name : '--' }} : {{ currentVersion.auditComment }}</span>
            </a-step>
            <a-step title="待发布" >
              <span slot="description">
                
              </span>
            </a-step>
          </a-steps>
          <a-steps v-if="currentVersion.auditStatus == -1 && currentVersion.onlineStatus != 1" :current="0">
            <a-step title="已撤回" :sub-title="$moment(currentVersion.withdrawTime).format('yyyy-MM-DD HH:mm:ss')">
              <span slot="description">{{ currentVersion.submitter ? currentVersion.submitter.name : '--' }} : {{ currentVersion.summary }}</span>
              <a-icon slot="icon" type="close-circle" />
            </a-step>
            <a-step title="未审核"/>
            <a-step title="未发布"/>
          </a-steps>
          <a-steps v-if="currentVersion.auditStatus == -2 && currentVersion.onlineStatus != 1" :current="1">
            <a-step title="上传完毕" :sub-title="$moment(currentVersion.gmtModified).format('yyyy-MM-DD HH:mm:ss')">
              <span slot="description">{{ currentVersion.submitter ? currentVersion.submitter.name : '--' }} : {{ currentVersion.summary }}</span>
            </a-step>
            <a-step title="审核不通过" :sub-title="$moment(currentVersion.auditTime).format('yyyy-MM-DD HH:mm:ss')">
              <span slot="description">{{ currentVersion.auditor ? currentVersion.auditor.name : '--' }} : {{ currentVersion.auditComment }}</span>
              <a-icon slot="icon" type="close-circle" />
            </a-step>
            <a-step title="未发布"/>
          </a-steps>
          <a-steps v-if="currentVersion.onlineStatus == 1" :current="2">
            <a-step title="上传完毕" :sub-title="$moment(currentVersion.gmtModified).format('yyyy-MM-DD HH:mm:ss')">
              <span slot="description">{{ currentVersion.submitter ? currentVersion.submitter.name : '--' }} : {{ currentVersion.summary }}</span>
            </a-step>
            <a-step title="审核通过" :sub-title="$moment(currentVersion.auditTime).format('yyyy-MM-DD HH:mm:ss')">
              <span slot="description">{{ currentVersion.auditor ? currentVersion.auditor.name : '--' }} : {{ currentVersion.auditComment }}</span>
            </a-step>
            <a-step title="已发布"/>
          </a-steps>
        </div>
        <div style="text-align: center" v-if="currentVersion.auditStatus == 1 && currentVersion.onlineStatus != 1">
          <CommonPermissions :p="$permissions.TEXTBOOK.AUDIT">
            <a-button type="primary" class="edit-btn" @click="openAuditModal" icon="form" >提交审核意见</a-button>
          </CommonPermissions>
        </div>
        <div style="text-align: right" v-if="currentVersion.auditStatus == 2">
          <CommonPermissions :p="$permissions.TEXTBOOK.RELEASE">
            <a-popconfirm
              class="edit-btn"
              title="确认发布此教材？"
              ok-text="是"
              cancel-text="否"
              @confirm="confirmPublich">
                <a-button type="primary" class="edit-btn" @click="openPublishModal" icon="form" >发布</a-button>
            </a-popconfirm>
          </CommonPermissions>
        </div>
        <a-card title="教材修改章节对比" :bordered="false">
          <a-collapse :bordered="false">
            <a-collapse-panel v-for="unit in toc"  :key="unit.id">
              <div slot="header" style="display: flex;justify-content: space-between;">
                <div>
                  {{ unit.name }}
                </div>
                <div> 
                  <CommonPermissions :p="$permissions.TEXTBOOK.AUDIT">
                    <a-button v-if="unit.auditStatus==2" size="small" type="primary" @click="(e) => publishUnit(e, unit)">审核通过</a-button>
                  </CommonPermissions>
                </div>
              </div>
              <a-list item-layout="horizontal" :data-source="unit.lessonList">
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <a-tag v-if="item.isNew" slot="actions" color="green">有新增</a-tag>
                  <a-tag v-if="item.isChanged" slot="actions" color="orange">有修改</a-tag>
                  <a slot="actions" @click="goCompare(item)">查看</a>
                  <a-list-item-meta>
                    <div slot="title">{{ item.name }}</div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-card>
        <a-button type="primary" block class="preview-btn" icon="read" @click="goReaderHtml">预览教材</a-button>
      </a-drawer>
    </a-spin>
  </a-row>
</template>
<script>
import fetch from 'isomorphic-fetch'
import TextBookApi from '../../../api/src/textbook/api/TextBookApi.js'
import CommonPermissions from '@/components/CommonPermissions'
const textBookApi = new TextBookApi()
const versionColumns = [
  {
    title: '版本',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    scopedSlots: { customRender: 'gmtCreate' },
  },
  {
    title: '审核状态',
    dataIndex: 'auditStatus',
    key: 'auditStatus',
    scopedSlots: { customRender: 'auditStatus' },
  },
  {
    title: '提交人',
    dataIndex: 'submitter',
    key: 'submitter',
    scopedSlots: { customRender: 'submitter' },
  },
  {
    title: '审核人',
    key: 'auditor',
    dataIndex: 'auditor',
    scopedSlots: { customRender: 'auditor' },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  name: "TextbookChapter",
  components: {
    CommonPermissions,
  },
  data() {
    return {
      loading: false,
      textbookId: undefined,

      versionListModalVisible: false,
      versionColumns: versionColumns,
      versionList: [],
      currentVersionId: undefined,
      currentVersion: {},

      toc: [],
      currentMD5Map: {},
      prevToc: [],
      prevMD5Map: {},
      prevVersion: {},

      auditModalVisible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      auditForm: {
        auditStatus: undefined,
        auditComment: undefined,
      },

      publishModalVisible: false,


      textbookDetail: {},
    }
  },
  async created() {
    const {id} = this.$route.params;
    const { versionId } = this.$route.query
    this.textbookId = id
    this.loading = true
    // let toc = await this.$store.dispatch('textbook/getTocV2', {id, type: 1})
    // console.log(toc)
    // toc.forEach((unit, unitIndex) => {
    //   unit._title = unit.title
    //   unit.sortKey = unitIndex
    //   if(unit.lessonList){
    //     unit.lessonList.forEach((lesson, lessonIndex) => {
    //       lesson._title = lesson.title
    //       lesson.sortKey = lessonIndex
    //       if(lesson.sectionList){
    //         lesson.sectionList.forEach((section, sectionIndex) => {
    //           section._title = section.title
    //           section.sortKey = sectionIndex
    //         });
    //       }
    //     });
    //   }
    // });
    let textbookDetail = await this.$store.dispatch('textbook/findTextBookById', {id})
    console.log("textbookDetail===")
    console.log(textbookDetail)
    // this.toc = toc
    this.textbookDetail = textbookDetail
    await this.getTextbookVersionList()
    // console.log('this.toc')
    // console.log(this.toc)
    // await this.init(versionId)
    this.loading = false
  },
  mounted() {
  },
  methods: {
    changePrevVersion() {

    },
    goCompare(lesson) {
      console.log(lesson)
      let unitId = undefined
      for(let i = 0; i < this.toc.length; i++) {
        let unit = this.toc[i]
        for(let j = 0; j < unit.lessonList.length; j++) {
          let lessonObj = unit.lessonList[j]
          if(lessonObj.id == lesson.id) {
            unitId = unit.id
            break
          }
        }
      }
      const { href } = this.$router.resolve({name: 'reader_2',params:{
        textbookId: this.textbookId,
        unitId: unitId,
        lessonId: lesson.id
      }, query: {versionId: this.currentVersionId, diffVersionId: this.prevVersion.id, lessonId: lesson.id, unitId: unitId}})
      //在新页面打开
      console.log(href)
      window.open(href)
    },
    async getCurrentVersion(versionId) {
      this.loading = true
      let currentVersion = await textBookApi.getVersion(this.textbookId, versionId)
      this.currentVersion = currentVersion
      this.loading = false
      return currentVersion
    },
    openPublishModal() {
      this.publishModalVisible = true
    },
    async confirmPublich() {
      this.loading = true
      let resp = await textBookApi.releaseVersion(this.textbookId, this.currentVersionId)
      console.log(resp)
      await this.getCurrentVersion(this.currentVersionId)
      this.publishModalVisible = false
      this.loading = false
    },
    async openVersionListModal(version) {
      this.versionListModalVisible = true
      await this.init(version.id)
    },
    closeVersionListModal() {
      this.versionListModalVisible = false
    },
    openAuditModal() {
      this.auditModalVisible = true
    },
    async handleAuditOk() {
      this.loading = true
      console.log(this.auditForm)
      console.log(this.currentVersionId)
      let resp = await textBookApi.auditVersion(this.textbookId, this.currentVersionId, {
        id: this.currentVersionId,
        textbookId: this.textbookId,
        auditStatus: this.auditForm.auditStatus,
        auditComment: this.auditForm.auditComment,
      })
      console.log(resp)
      this.auditForm = {
        auditStatus: undefined,
        auditComment: undefined,
      }
      await this.getTextbookVersionList()
      await this.getCurrentVersion(this.currentVersionId)
      this.auditModalVisible = false
      this.loading = false
    },
    async getTextbookVersionList() {
      this.loading = true
      let versionList = await textBookApi.getVersionList(this.textbookId)
      console.log(versionList)
      this.versionList = versionList
      this.loading = false
    },
    async handleChangeVersion(versionId) {
      this.currentVersionId = versionId
    },
    async getTOCJSON(textbookId, currentVersionId) {
      let resp = await fetch(`//bookcdn.aefree.com/reader/${textbookId}/${currentVersionId}/src/router/toc.json`)
      let data = await resp.json()
      console.log(data)
      return data
    },
    async getMD5JSON(textbookId, currentVersionId) {
      let resp = await fetch(`//bookcdn.aefree.com/reader/${textbookId}/${currentVersionId}/dist/${textbookId}/html-md5-map.json`)
      let data = await resp.json()
      console.log(data)
      return data
    },
    async init(versionId) {
      this.loading = true
      console.log(this.textbookId)
      console.log(versionId)
      this.currentVersionId = versionId
      await this.getCurrentVersion(versionId)
      let data = await this.getTOCJSON(this.textbookId, versionId)
      this.currentMD5Map = await this.getMD5JSON(this.textbookId, versionId)
      let {prevToc, prevMD5Map} = await this.getPrevTOCAndMD5Map(versionId)
      this.prevToc = prevToc
      this.prevMD5Map = prevMD5Map
      this.toc = this.diffTOC(data.unitList, this.currentMD5Map, this.prevMD5Map)
      console.log(this.toc)
      this.loading = false
    },
    async getPrevTOCAndMD5Map(versionId) {
      let prevToc = []
      let prevMD5Map = {}
      let currentVersionIndex = undefined
      for(let i = 0; i < this.versionList.length; i++) {
        if(versionId == this.versionList[i].id) {
          currentVersionIndex = i
          break;
        }
      }
      if(currentVersionIndex >= 0 && currentVersionIndex != this.versionList.length - 1) {
        let prevVersion = this.versionList[currentVersionIndex + 1]
        this.prevVersion = prevVersion
        let data = await this.getTOCJSON(this.textbookId, prevVersion.id)
        prevToc = data.unitList
        prevMD5Map = await this.getMD5JSON(this.textbookId, prevVersion.id)
        console.log('prevMD5Map')
        console.log(prevMD5Map)
      }
      return {prevToc, prevMD5Map}
    },
    diffTOC(unitList, currentMD5Map, prevMD5Map) {
      for(let i = 0; i < unitList.length; i++) {
        let unit = unitList[i]
        for(let j = 0; j < unit.lessonList.length; j++) {
          let lesson = unit.lessonList[j]
          if(prevMD5Map[lesson.id] && prevMD5Map[lesson.id] != currentMD5Map[lesson.id]) {
            lesson.isChanged = true
          } else if(!prevMD5Map[lesson.id]) {
            lesson.isNew = true
          }
        }
      }
      return unitList
    },
    goReaderHtml() {
      // const { href } = this.$router.resolve({name: 'reader',params:{
      //   textbookId: this.textbookId,
      //   versionId: this.currentVersionId
      // }})
      let href = `http://reader.fmyundianji.com/reader/${this.textbookId}?versionId=${this.currentVersionId}`
      //在新页面打开
      window.open(href)
    }
  }
}
</script>

<style lang="less" scoped>
.chapter-view{
  display: flex;
  flex-direction: column;

  .unit-title{
    height: 40px;
    font-size: 18px;
    font-weight: bold;
    background: linear-gradient(to right, #ecf5ff, #ffffff);
    line-height: 40px;
    padding-left: 5px;
    border-radius: 4px;
  }
  .lesson-title{
    height: 40px;
    font-size: 16px;
    margin-left: 10px;
    margin-right: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 40px;
    cursor: pointer;
  }
  .section-title{
    height: 30px;
    font-size: 14px;
    margin-left: 30px;
    margin-right: 20px;
    cursor: pointer;
  }
}
.action-view{
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  margin-bottom: 20px;
  .edit-btn{
    margin-left: auto;
  }
}

.book-info-view{
  display: flex;
  flex-direction: row;
  .book-info{
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    margin-right: 20px;
  }

}
</style>